//let apiDomain = "http://papasdevwebapi.dgmonglab.com"; //개발서버
 const apiDomain = "https://papaswebapi.dgmonglab.com"; //실서버
let apiURL = `${apiDomain}/api/`;

function setterApiDomain(domain) {
    apiDomain = domain;
    apiURL = `${domain}/api/`
}

export {apiURL, apiDomain, setterApiDomain};
